import { JoiTranslatesScheme } from "./DtoTranslateScheme";
import { JoiCuisineScheme } from "./DtoCuisineScheme";
import Joi from "joi";
import { OrderType } from "@constants/ordering/orderTypes";

export const JoiTechnicalRestaurantScheme = Joi.object({
  allow_order_for_else: Joi.boolean().required(),
  applepay_enabled: Joi.boolean().required(),
  certificate: Joi.string().allow("").required(),
  client_id: Joi.number().required(),
  cuisines: Joi.array().items(JoiCuisineScheme),
  currency: Joi.string().allow("").required(),
  currency_code: Joi.string().allow("").required(),
  currency_name: JoiTranslatesScheme,
  description: JoiTranslatesScheme,
  domain: Joi.string().allow("").required(),
  hasActiveCashback: Joi.boolean(),
  id: Joi.number().required(),
  image: Joi.string().allow("").required(),
  image_md: Joi.string().allow("").required(),
  img_logo: Joi.string().allow("").required(),
  isCashbackEnabled: Joi.boolean(),
  isWalletEnabled: Joi.boolean(),
  item_notes: Joi.boolean().required(),
  name: JoiTranslatesScheme,
  order_notes: Joi.boolean().required(),
  order_type: Joi.number()
    .valid(OrderType.Pickup, OrderType.Delivery, OrderType.Both)
    .required(),
  status: Joi.boolean().required(),
  vat: Joi.number().required(),
  vat_included: Joi.boolean().required(),
  vat_registration_number: Joi.string().allow("").required(),
  working_now: Joi.boolean(),
});
